/**
 * @owner @Appboy/messaging-experience
 */
import { canvasRemoteLookupValidators } from "../.generated/canvasRemoteLookup";
import type { CanvasRemoteLookupProvider } from "../.generated/canvasRemoteLookup";

export const canvasProvider: CanvasRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  // The backend searches Canvases on name; match on name only (display fallbacks
  // for unnamed Canvases belong in the consuming RemoteSelect's mapItemToOption).
  mapItemToSearchString: (item) => item.name ?? "",
  validators: canvasRemoteLookupValidators,
};
